import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-676a897e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "material-selector-teaser" }
const _hoisted_2 = { class: "material-selector-teaser__thumbnail-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "material-selector-teaser__inner" }
const _hoisted_5 = { class: "material-selector-teaser__title" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "material-selector-teaser" }
const _hoisted_8 = { class: "material-selector-teaser__thumbnail-container" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "material-selector-teaser__inner" }
const _hoisted_11 = { class: "material-selector-teaser__title" }
const _hoisted_12 = ["innerHTML"]

import { useStore } from "vuex";
import { isEmpty } from "lodash";
import { computed } from "vue";
import { materialProduct } from "@/types/product";


export default /*#__PURE__*/_defineComponent({
  __name: 'MaterialSelector',
  setup(__props) {

const i18n = window.measurementSelectorVariables.i18n;
const store = useStore();
const currentProductMaterial = computed(() => store.getters.currentProductMaterial);
const alternateMaterials = computed(() => store.getters.alternateMaterials);
const baseShapeInstance = computed(() => store.getters.baseShapeInstance);

function pricePerSquareMeter( option: materialProduct ): string {
	return `${option.price} / ${option.unit} ${option.suffix}`;
}

async function setMaterial( material: materialProduct ): Promise<void> {
	if ( material.id === currentProductMaterial.value.id ) {
		return;
	}

	store.commit('updateMaterial', material);
	const url = await getUrl( material );

	if ( url === '' ) {
		return;
	}

	location.href = url;
}

async function getUrl( material: materialProduct ): Promise<string> {
	if ( isEmpty( baseShapeInstance.value ) ) {
		return material.permalink;
	}

	return await store.dispatch( 'generateShareableLink', {
		url: material.permalink,
		isTemporary: true
	} );
}


return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(_component_v_select, {
    label: "title",
    class: "material-selector",
    inputId: "measurements-selector-material-select",
    modelValue: currentProductMaterial.value,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((currentProductMaterial).value = $event)),
      setMaterial
    ],
    options: alternateMaterials.value,
    clearable: false,
    placeholder: _unref(i18n).material.selectMaterial
  }, {
    option: _withCtx((option) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (option.image)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "material-selector-teaser__image",
                src: option.image,
                alt: "",
                width: "60",
                height: "60",
                loading: "lazy"
              }, null, 8, _hoisted_3))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(option.title), 1),
          (option.price)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "material-selector-teaser__subtitle",
                innerHTML: pricePerSquareMeter( option )
              }, null, 8, _hoisted_6))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    "selected-option": _withCtx((option) => [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (option.image)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "material-selector-teaser__image",
                src: option.image,
                alt: "",
                width: "60",
                height: "60",
                loading: "lazy"
              }, null, 8, _hoisted_9))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(option.title), 1),
          (option.price)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "material-selector-teaser__subtitle",
                innerHTML: pricePerSquareMeter( option )
              }, null, 8, _hoisted_12))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "options", "placeholder"]))
}
}

})